import type { Conversation } from '../types';

export interface ShortcutLike {
  atalho: string;
}

export const sanitizeManualPhone = (input: string): string => {
  const digits = input.replace(/\D/g, '');

  if (digits.length < 10 || digits.length > 13) {
    throw new Error('Telefone inválido');
  }

  const withDdi = digits.startsWith('55') ? digits : `55${digits}`;
  let corpo = withDdi.slice(2);

  if (corpo.length === 11 && corpo[2] === '9') {
    corpo = corpo.slice(0, 2) + corpo.slice(3);
  }

  const ddd = corpo.slice(0, 2);
  const last8 = corpo.slice(-8);

  if (ddd.length !== 2 || last8.length !== 8) {
    throw new Error('Telefone inválido');
  }

  return `${ddd}${last8}`;
};

export const getDisplayName = (conversation: Conversation): string => {
  return (conversation.apelido && conversation.apelido.trim() !== '')
    ? conversation.apelido
    : (conversation.chat_name || conversation.name || 'Cliente');
};

export const filterShortcutsByPrefix = <T extends ShortcutLike>(
  shortcuts: T[],
  message: string,
): T[] => {
  if (!message.startsWith('/')) return [];
  const prefix = message.slice(1).toLowerCase();
  return shortcuts.filter((s) => s.atalho.toLowerCase().startsWith(prefix));
};
